import React from 'react';
import { FadeIn, Section, SectionLabel, Card } from './UI';
export const SolutionSection = () => {
  return <>
      <Section className="bg-sectionAlt" data-id="element-161">
        <FadeIn data-id="element-162">
          <SectionLabel data-id="element-163">¿Qué aprenderás?</SectionLabel>
          <h2 className="font-serif text-[clamp(1.9rem,4vw,2.8rem)] leading-[1.2] text-headline mb-5 font-bold" data-id="element-164">
            6 módulos prácticos para
            <br data-id="element-165" />
            <span className="text-accent" data-id="element-166">crear tu empresa en USA.</span>
          </h2>
          <p className="text-body mb-10 text-[1.05rem]" data-id="element-167">
            No es un curso de 40 horas. No es teoría genérica. Es un{' '}
            <strong className="text-headline" data-id="element-168">mapa ejecutable</strong>. Para
            personas que ya quieren moverse y solo necesitan saber exactamente
            cómo.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-169">
            {[{
            num: '01',
            title: 'LLC vs Corporation',
            desc: 'Elige la estructura correcta según tu negocio y protege tu patrimonio personal desde el primer día.'
          }, {
            num: '02',
            title: 'Registro en Sunbiz',
            desc: 'Paso a paso en el portal oficial de Florida. Sin confusiones, sin errores.'
          }, {
            num: '03',
            title: 'Tu EIN',
            desc: 'Cómo obtener tu número de identificación fiscal con o sin Número de Seguro Social.'
          }, {
            num: '04',
            title: 'Operating Agreement',
            desc: 'El documento que los bancos exigen. Incluye plantilla lista para usar.'
          }, {
            num: '05',
            title: 'Cuenta Bancaria',
            desc: 'Mercury, Chase, Bank of America: cuál abre sin SSN y cómo hacerlo correctamente.'
          }, {
            num: '06',
            title: 'Cumplimiento Legal',
            desc: 'Reporte Anual y BOI: evita multas de $400 y $500 por día.'
          }].map((item, i) => <Card key={i} className="p-7 hover:border-accent/40 transition-colors" data-id="element-170">
                <span className="font-serif text-[1.6rem] text-accent font-bold block mb-3" data-id="element-171">
                  {item.num}
                </span>
                <h3 className="font-serif text-[1.15rem] mb-3 text-headline font-bold" data-id="element-172">
                  {item.title}
                </h3>
                <p className="text-[0.95rem] text-body m-0 leading-relaxed" data-id="element-173">
                  {item.desc}
                </p>
              </Card>)}
          </div>
        </FadeIn>
      </Section>

      <Section className="bg-pageBg" data-id="element-174">
        <FadeIn data-id="element-175">
          <SectionLabel data-id="element-176">Lo que obtienes de verdad</SectionLabel>
          <h2 className="font-serif text-[clamp(1.9rem,4vw,2.8rem)] leading-[1.2] text-headline mb-8 font-bold" data-id="element-177">
            Después de leer Ruta USA 360,
            <br data-id="element-178" />
            <span className="text-accent" data-id="element-179">tu vida se ve así:</span>
          </h2>

          <Card className="p-2" data-id="element-180">
            <ul className="divide-y divide-cardBorder" data-id="element-181">
              {[<>
                  <strong className="text-accent" data-id="element-182">Claridad total</strong> sobre
                  qué pasos seguir y en qué orden exacto
                </>, <>
                  <strong className="text-accent" data-id="element-183">Confianza</strong> para
                  ejecutar sin miedo a equivocarte
                </>, <>
                  <strong className="text-accent" data-id="element-184">Tiempo ahorrado</strong>, sin
                  más horas de búsqueda infructuosa
                </>, <>
                  <strong className="text-accent" data-id="element-185">Dinero protegido</strong>,
                  evitando errores costosos desde el inicio
                </>, <>
                  <strong className="text-accent" data-id="element-186">Estructura real</strong> para
                  no perderte en el proceso
                </>, <>
                  Tu empresa{' '}
                  <strong className="text-accent" data-id="element-187">
                    lista para operar, facturar y crecer legalmente en USA
                  </strong>
                </>].map((item, i) => <li key={i} className="flex gap-4 items-start py-5 px-5 text-[1.05rem] text-body" data-id="element-188">
                  <span className="bg-deepPurple text-white w-7 h-7 rounded-full flex items-center justify-center text-[0.85rem] shrink-0 mt-[2px]" data-id="element-189">
                    ✓
                  </span>
                  <div data-id="element-190">{item}</div>
                </li>)}
            </ul>
          </Card>
        </FadeIn>
      </Section>

      <Section className="bg-sectionAlt" data-id="element-191">
        <FadeIn data-id="element-192">
          <SectionLabel data-id="element-193">¿Es para ti?</SectionLabel>
          <h2 className="font-serif text-[clamp(1.9rem,4vw,2.8rem)] leading-[1.2] text-headline mb-8 font-bold" data-id="element-194">
            Esta guía es para ti
            <br data-id="element-195" />
            <span className="text-accent" data-id="element-196">si reconoces esto:</span>
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-197">
            <Card className="p-7 border-accent/30 bg-cardBorder/30" data-id="element-198">
              <h3 className="text-headline mb-5 text-[1rem] tracking-[1px] uppercase font-bold flex items-center gap-2" data-id="element-199">
                <span className="text-accent" data-id="element-200">✅</span> Sí es para ti
              </h3>
              <ul className="space-y-4" data-id="element-201">
                {['Ya investigaste pero aún tienes dudas', 'Quieres hacerlo bien desde el principio', 'Necesitas ordenar la información', 'Quieres avanzar con seguridad', 'Estás listo para ejecutar esta semana'].map((item, i) => <li key={i} className="text-[0.97rem] text-body flex items-start gap-3" data-id="element-202">
                    <span className="text-accent font-bold mt-1" data-id="element-203">✔</span>{' '}
                    {item}
                  </li>)}
              </ul>
            </Card>

            <Card className="p-7 border-red-200 bg-red-50/30" data-id="element-204">
              <h3 className="text-headline mb-5 text-[1rem] tracking-[1px] uppercase font-bold flex items-center gap-2" data-id="element-205">
                <span className="text-red-500" data-id="element-206">❌</span> No es para ti
              </h3>
              <ul className="space-y-4" data-id="element-207">
                {['Buscas excusas para seguir esperando', 'Quieres más información sin estructura', 'No planeas tomar acción pronto', 'Esperas que alguien lo haga por ti'].map((item, i) => <li key={i} className="text-[0.97rem] text-body flex items-start gap-3" data-id="element-208">
                    <span className="text-red-500 font-bold mt-1" data-id="element-209">✘</span>{' '}
                    {item}
                  </li>)}
              </ul>
            </Card>
          </div>
        </FadeIn>
      </Section>
    </>;
};